import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { IStockStatusResponsePayload } from "./product-stock-status.actions";

export const productStockStatusAdapter: EntityAdapter<IStockStatusResponsePayload> = createEntityAdapter<IStockStatusResponsePayload>({
	selectId: item => item.sku,
});